var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIconSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2637_9080",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2637_9080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.448 15.748H14.548",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.084 1.98562L11.115 2.05662L14.075 8.92362H16.985C17.6585 8.92406 18.3251 9.0601 18.945 9.32362L17.154 5.05862L17.113 4.95862L17.042 4.79562C17.0245 4.73527 17.0007 4.67695 16.971 4.62162C15.637 1.52362 14.126 0.823624 11.084 1.98562Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58099 9.13135C6.04825 8.99288 6.53368 8.92546 7.02099 8.93135H14.076L11.118 2.05635L11.087 1.98535C10.934 2.03635 10.787 2.10835 10.638 2.16935L8.37799 3.11835C7.36593 3.46701 6.45328 4.05542 5.71799 4.83335C5.62047 4.94685 5.53501 5.07018 5.46299 5.20135C5.37388 5.33638 5.3064 5.4845 5.26299 5.64035C5.22485 5.72591 5.19407 5.81457 5.17099 5.90535C4.93041 6.99574 5.07531 8.13581 5.58099 9.13135Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03601 13.9118V15.9028C2.03601 16.1028 2.04601 16.3108 2.05601 16.5158C2.25001 20.0788 4.24101 21.8758 8.01801 21.8758H15.981C16.2235 21.8744 16.4657 21.8574 16.706 21.8248C19.9527 21.6101 21.686 19.8768 21.906 16.6248C21.9386 16.3845 21.9556 16.1423 21.957 15.8998V13.9118C21.9554 12.9362 21.6685 11.9824 21.1315 11.1679C20.5945 10.3534 19.831 9.71373 18.935 9.32779C18.3148 9.06528 17.6485 8.92929 16.975 8.92779H7.00801C6.52093 8.92546 6.03602 8.99281 5.56801 9.12779C4.54523 9.44292 3.65036 10.0775 3.0147 10.9385C2.37903 11.7995 2.03603 12.8416 2.03601 13.9118Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.158 5.05859L18.945 9.32559C19.8408 9.71169 20.6041 10.3514 21.1409 11.1659C21.6777 11.9804 21.9645 12.9341 21.966 13.9096V10.9196C21.967 9.53709 21.4882 8.19708 20.6114 7.12822C19.7345 6.05935 18.514 5.32787 17.158 5.05859Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04004 10.9186V13.9096C2.03952 12.8412 2.38259 11.8009 3.01858 10.9423C3.65458 10.0837 4.54979 9.45245 5.57204 9.14162C5.07172 8.1411 4.92137 7.00169 5.14504 5.90563C5.16493 5.81391 5.19582 5.72493 5.23704 5.64062C4.27218 6.14358 3.46385 6.90168 2.90012 7.83235C2.3364 8.76302 2.0389 9.83054 2.04004 10.9186Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIconSmall);
export default __webpack_public_path__ + "static/media/wallet-icon-small.47e2c464963e9ac9707ac0ad144cfc19.svg";
export { ForwardRef as ReactComponent };